import "../jquery";
import "bootstrap";
import bootbox from "bootbox";
import { blurApp } from "./commons";
export async function alertBox(conf) {
    return new Promise((resolve) => {
        blurApp(true);
        bootbox.dialog({
            message: conf.message,
            size: conf.size,
            closeButton: false,
            className: `kboot ${conf.dark ? "kboot-dark" : "kboot-light"}`,
            buttons: {
                button: {
                    label: conf.buttonText || "OK",
                    className: "btn btn-primary btn-xs",
                    callback: async () => {
                        try {
                            if (conf.func) {
                                await conf.func();
                            }
                        }
                        finally {
                            blurApp(false);
                            resolve();
                        }
                    },
                },
            },
        });
    });
}
export async function confirmBox(conf) {
    return new Promise((resolve) => {
        blurApp(true);
        bootbox.dialog({
            message: conf.message,
            size: conf.size,
            closeButton: false,
            className: `kboot ${conf.dark ? "kboot-dark" : "kboot-light"}`,
            buttons: {
                yesButton: {
                    label: conf.yesText || "YES",
                    className: "btn btn-primary btn-xs",
                    callback: async () => {
                        try {
                            if (conf.yesFunc) {
                                await conf.yesFunc();
                            }
                        }
                        finally {
                            blurApp(false);
                            resolve(true);
                        }
                    },
                },
                noButton: {
                    label: conf.noText || "NO",
                    className: "btn btn-secondary btn-xs",
                    callback: async () => {
                        try {
                            if (conf.noFunc) {
                                await conf.noFunc();
                            }
                        }
                        finally {
                            blurApp(false);
                            resolve(false);
                        }
                    },
                },
            },
        });
    });
}
function convertToNumber(value) {
    if (!value) {
        return undefined;
    }
    return +value;
}
function getErrorMessage(errorMessage, prop) {
    if (!errorMessage) {
        return undefined;
    }
    if (typeof errorMessage === "string") {
        return errorMessage;
    }
    return errorMessage[prop];
}
export async function promptBox(conf) {
    return new Promise((resolve) => {
        blurApp(true);
        const options = {
            title: conf.message,
            message: `<div class="prompt-message">${conf.message}<span class="error-message"></span></div>`,
            size: conf.size,
            closeButton: false,
            className: `kboot ${conf.dark ? "kboot-dark" : "kboot-light"} kprompt`,
            inputType: conf.type,
            value: conf.value !== undefined ? `${conf.value}` : undefined,
            buttons: {
                cancel: {
                    label: conf.cancelText || "CANCEL",
                    className: "btn btn-secondary btn-xs",
                },
                confirm: {
                    label: conf.confirmText || "OK",
                    className: "btn btn-primary btn-xs",
                },
            },
            callback: () => { },
        };
        if (conf.type === "radio") {
            options.inputOptions = conf.options.map((o) => ({ text: o.label, value: o.value }));
        }
        const bb = bootbox.prompt({
            ...options,
            callback: (result) => {
                if (result === "" || result === undefined) {
                    bb.find(".bootbox-input").addClass("error");
                    const errorMessage = getErrorMessage(conf.errorMessage, "required");
                    if (errorMessage) {
                        bb.find(".error-message").text(errorMessage);
                    }
                    return false;
                }
                const converted = convertToNumber(result);
                switch (conf.type) {
                    case "number":
                        if (converted !== undefined && ((conf.minValue !== undefined && converted < conf.minValue) || (conf.maxValue !== undefined && converted > conf.maxValue))) {
                            bb.find(".bootbox-input").addClass("error");
                            const errorMessage = getErrorMessage(conf.errorMessage, "range");
                            if (errorMessage) {
                                bb.find(".error-message").text(errorMessage);
                            }
                            return false;
                        }
                        break;
                    case "text":
                        if (result !== null && ((conf.minLength !== undefined && result.length < conf.minLength) || (conf.maxLength !== undefined && result.length > conf.maxLength))) {
                            bb.find(".bootbox-input").addClass("error");
                            const errorMessage = getErrorMessage(conf.errorMessage, "range");
                            if (errorMessage) {
                                bb.find(".error-message").text(errorMessage);
                            }
                            return false;
                        }
                        break;
                    case "radio":
                        break;
                }
                try {
                    if (result !== null && conf.confirmFunc) {
                        conf.confirmFunc((conf.type !== "number" ? result : converted));
                    }
                    else if (result === null && conf.cancelFunc) {
                        conf.cancelFunc();
                    }
                }
                finally {
                    blurApp(false);
                    resolve(result === null ? undefined : conf.type !== "number" ? result : converted);
                }
            },
        });
    });
}
